import { Typography } from '@julo-ui/react';
import { NT80 } from '@julofinance/color-token';
import Drawer from '@mui/material/Drawer';

import { Button } from '@new-components/elements';

import { bottomSheeetContainer } from './styles';
import { BottomSheetProps } from './types';

const BottomSheetErrorMessage = ({
  display,
  onSuccess,
  onClose,
  ctaText = 'Mengerti',
  title,
  description,
  children,
  loading = false,
  noAction = false,
}: BottomSheetProps) => {
  return (
    <Drawer
      anchor='bottom'
      open={display}
      onClose={onClose}
      PaperProps={{
        className: bottomSheeetContainer,
      }}
    >
      <h3>{title}</h3>
      <hr />
      {children || (
        <Typography type='body' bold color={NT80} sx={{ marginBottom: '16px' }}>
          {description}
        </Typography>
      )}
      {!noAction ? (
        <Button
          loading={loading}
          onClick={() => {
            if (onSuccess) {
              onSuccess();
            } else {
              onClose();
            }
          }}
        >
          {ctaText}
        </Button>
      ) : null}
    </Drawer>
  );
};

export default BottomSheetErrorMessage;
